var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBiPeopleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 26.25C13.125 26.25 11.25 26.25 11.25 24.375C11.25 22.5 13.125 16.875 20.625 16.875C28.125 16.875 30 22.5 30 24.375C30 26.25 28.125 26.25 28.125 26.25H13.125ZM20.625 15C22.1168 15 23.5476 14.4074 24.6025 13.3525C25.6574 12.2976 26.25 10.8668 26.25 9.375C26.25 7.88316 25.6574 6.45242 24.6025 5.39752C23.5476 4.34263 22.1168 3.75 20.625 3.75C19.1332 3.75 17.7024 4.34263 16.6475 5.39752C15.5926 6.45242 15 7.88316 15 9.375C15 10.8668 15.5926 12.2976 16.6475 13.3525C17.7024 14.4074 19.1332 15 20.625 15Z",
    fill: "#FF5F14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.78 26.2499C9.50204 25.6646 9.36342 25.0228 9.375 24.3749C9.375 21.8343 10.65 19.2187 13.005 17.3999C11.8295 17.0378 10.6049 16.8606 9.375 16.8749C1.875 16.8749 0 22.4999 0 24.3749C0 26.2499 1.875 26.2499 1.875 26.2499H9.78Z",
    fill: "#FF5F14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 15C9.6807 15 10.873 14.5061 11.7521 13.6271C12.6311 12.748 13.125 11.5557 13.125 10.3125C13.125 9.0693 12.6311 7.87701 11.7521 6.99794C10.873 6.11886 9.6807 5.625 8.4375 5.625C7.1943 5.625 6.00201 6.11886 5.12294 6.99794C4.24386 7.87701 3.75 9.0693 3.75 10.3125C3.75 11.5557 4.24386 12.748 5.12294 13.6271C6.00201 14.5061 7.1943 15 8.4375 15Z",
    fill: "#FF5F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiPeopleFill);
export default __webpack_public_path__ + "static/media/bi-people-fill.efcfe976c8605e84b0fb329acf3ca2d4.svg";
export { ForwardRef as ReactComponent };